"use client";

import { X, Keyboard } from "lucide-react";

const SHORTCUTS = [
  { keys: ["←", "→", "↑", "↓"], label: "Pan the view" },
  { keys: ["+", "−"],            label: "Zoom in / out" },
  { keys: ["Esc"],               label: "Close panels" },
  { keys: ["Tab"],               label: "Cycle through hotspots" },
  { keys: ["Enter"],             label: "Activate hotspot" },
  { keys: ["?"],                 label: "Show this help" },
  { keys: ["⌘K"],               label: "Global search" },
  { keys: ["⌘U"],               label: "Upload panorama" },
];

interface Props {
  onClose: () => void;
}

export default function KeyboardShortcutsModal({ onClose }: Props) {
  return (
    <div
      className="fixed inset-0 z-[300] flex items-center justify-center bg-black/60 backdrop-blur-sm"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="w-full max-w-sm mx-4 bg-tone-900 border border-ink/10 rounded-2xl shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-ink/8">
          <div className="flex items-center gap-2">
            <Keyboard className="w-4 h-4 text-indigo-400" />
            <span className="text-sm font-semibold text-ink">Keyboard Shortcuts</span>
          </div>
          <button onClick={onClose} className="text-tone-400 hover:text-ink transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Shortcuts list */}
        <div className="px-5 py-4 space-y-2.5">
          {SHORTCUTS.map(({ keys, label }) => (
            <div key={label} className="flex items-center justify-between">
              <span className="text-sm text-tone-300">{label}</span>
              <div className="flex items-center gap-1">
                {keys.map((k) => (
                  <kbd
                    key={k}
                    className="inline-flex items-center justify-center px-2 py-0.5 min-w-[1.75rem] h-6 rounded-md bg-ink/8 border border-ink/15 text-xs font-mono text-tone-200 shadow-sm"
                  >
                    {k}
                  </kbd>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="px-5 pb-4">
          <p className="text-xs text-tone-600">
            Press <kbd className="px-1.5 py-0.5 rounded bg-ink/8 border border-ink/10 text-xs font-mono text-tone-400">?</kbd> to toggle this panel
          </p>
        </div>
      </div>
    </div>
  );
}
